import { render } from "./Reports.vue?vue&type=template&id=248f2b04&scoped=true&lang=pug"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"

import "./Reports.vue?vue&type=style&index=0&id=248f2b04&scoped=true&lang=scss"
import "./Reports.vue?vue&type=style&index=1&id=248f2b04&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248f2b04"]])

export default __exports__